import React from 'react';
import PropTypes from 'prop-types';
import Svg from "./Svg";
import { isFirefox, isSafari } from "../../../helpers/common";

const LiftCountIcon = ({ count }) => (
	<Svg viewBox={'30 30'} width={30} height={30}>
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<rect fill="#4A4A4A" x="0" y="0" width="30" height="30" rx="8"/>
			<rect fill="#FFFFFF" x="2.64705882" y="2.64705882" width="24.7058824" height="24.7058824" rx="6"/>

			<g transform="translate(2.433558, 1.678279)" fill="#000000">
				<g
					transform="translate(12.352941, 13.676471) rotate(-25.000000) translate(-12.352941, -13.676471) translate(3.529412, 3.529412)">
					<path
						d="M1.37077656,16.2327747 L1.46836576,16.2423067 L14.8963738,18.5557212 C15.3440949,18.6328558 15.7933082,18.427565 16.0280052,18.0385647 L16.0280052,18.0385647 L16.0905816,17.9465412 C16.2949651,17.6926089 16.6606474,17.6224756 16.9475068,17.7955476 C17.2604443,17.9843534 17.3610729,18.3910967 17.1722671,18.7040342 L17.1722671,18.7040342 L17.0709082,18.861145 C16.535121,19.6263561 15.6019279,20.0203038 14.671663,19.8600352 L14.671663,19.8600352 L1.24365493,17.5466208 C0.883478547,17.4845686 0.641801136,17.1422847 0.70385332,16.7821084 C0.765905504,16.421932 1.10818938,16.1802546 1.46836576,16.2423067 Z M6.33231033,5.45851783 C7.17441557,5.45851783 7.85707674,6.14117901 7.85707674,6.98328424 L7.85707674,6.98328424 L7.85707674,10.3027896 L10.6017183,10.9155709 C10.7164178,10.9411793 10.8277103,10.9801786 10.933306,11.0317665 C11.6776539,11.3954114 11.9862747,12.2936171 11.6226298,13.037965 L11.6226298,13.037965 L9.81142291,16.7453401 C9.59051071,17.1975272 9.05275762,17.3956494 8.59127688,17.1948737 C8.58036059,17.1901243 8.56954368,17.1851497 8.55883312,17.179953 C8.12982865,16.9718033 7.95079049,16.4552878 8.1589402,16.0262833 L8.1589402,16.0262833 L9.52588273,13.2089627 L6.41544097,12.5870877 C5.48053163,12.4001699 4.80754392,11.5793121 4.80754392,10.6259005 L4.80754392,10.6259005 L4.80754392,6.98328424 C4.80754392,6.14117901 5.49020509,5.45851783 6.33231033,5.45851783 Z M4.47341022,0.549149858 C4.62786982,0.217910173 5.02160689,0.0746015999 5.35284657,0.229061202 C5.68408626,0.383520804 5.82739483,0.777257872 5.67293523,1.10849756 L5.67293523,1.10849756 L3.79173207,5.14275074 L3.67249494,11.3960812 C3.65448131,12.3407968 4.30479541,13.1673046 5.22723233,13.3720534 L5.22723233,13.3720534 L7.49401232,13.8751995 C7.85081108,13.9543964 8.07585186,14.3078407 7.99665498,14.6646394 C7.9174581,15.0214382 7.5640138,15.246479 7.20721504,15.1672821 L7.20721504,15.1672821 L4.94043505,14.664136 C3.40304018,14.3228879 2.31918335,12.945375 2.34920607,11.370849 L2.34920607,11.370849 L2.47378521,4.83735952 Z M7.75805252,1.98129371 C8.68458285,1.98129371 9.4356841,2.73239495 9.4356841,3.65892529 C9.4356841,4.58545563 8.68458285,5.33655687 7.75805252,5.33655687 C6.83152218,5.33655687 6.08042094,4.58545563 6.08042094,3.65892529 C6.08042094,2.73239495 6.83152218,1.98129371 7.75805252,1.98129371 Z"
					/>
				</g>
			</g>

			<text
				fontFamily="MapFont, Open Sans"
				fontSize="10"
				fontWeight={(isSafari || isFirefox) ? 'normal' : 'bold'}
				fill="#000000"
			>
				<tspan x="18.5294118" y="12.7058824">{count}</tspan>
			</text>
		</g>
	</Svg>
);

LiftCountIcon.defaultProps = {
	count: 4
};

LiftCountIcon.propTypes = {
	count: PropTypes.number
};

export default LiftCountIcon;
